
import { useState } from 'react';
import { Settings, Database, FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { useToast } from '../../hooks/use-toast';

const Manipulate = () => {
  const { toast } = useToast();

  const handleToolClick = (tool: string) => {
    toast({
      title: "Tool Selected",
      description: `You selected the ${tool} tool. This is a placeholder.`,
    });
  };

  return (
    <div className="p-6 h-full overflow-y-auto">
      <h1 className="text-3xl font-bold mb-8 text-bytesplash-blue">Data Manipulation Tools</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-lg font-semibold">System Settings</CardTitle>
            <Settings className="w-5 h-5 text-bytesplash-blue" />
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500 mb-4">
              Configure system settings, permissions, and access controls.
            </p>
            <Button
              className="w-full bg-bytesplash-blue hover:bg-blue-700"
              onClick={() => handleToolClick('System Settings')}
            >
              Configure Settings
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-lg font-semibold">Data Management</CardTitle>
            <Database className="w-5 h-5 text-bytesplash-blue" />
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500 mb-4">
              Backup, restore, and manage system data and records.
            </p>
            <Button
              className="w-full bg-bytesplash-blue hover:bg-blue-700"
              onClick={() => handleToolClick('Data Management')}
            >
              Manage Data
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-lg font-semibold">Reports</CardTitle>
            <FileText className="w-5 h-5 text-bytesplash-blue" />
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500 mb-4">
              Generate custom reports on attendance, performance, and more.
            </p>
            <Button
              className="w-full bg-bytesplash-blue hover:bg-blue-700"
              onClick={() => handleToolClick('Reports')}
            >
              Generate Reports
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Manipulate;
